export default __webpack_public_path__ + "static/media/insta.cd6b1ca1.svg";